$bog_bot $gd_bot
	Space null
	Sources null
	Donate null
	Support null
	Lights null
	Model? $bog_bot_model
		params * temperature 0
		rules <= context <= rules \Ты - Гипер Бот, универсальный интеллектуальный ассистент. Пользователь присылает тебе запрос в виде JSON строки. Твоя задача сформировать максимально точный и лаконичный ответ на запрос без лишней информации, о которой пользователь не просил. Ответ должен быть представлен в виде JSON объекта, где в поле "response" должен находиться собственно ответ в виде строки. В поле "confidence" отрази степень своей увернности в истинности ответа в диапазоне от 0 до 1. В поле "digest" должен находиться краткий пересказ всего вашего диалога от начала до конца. Говоря о пользователе в пересказе (и только в нём) используй эмодзи 🙂 вместо слова "пользователь", а вместо "Гипер Бота" - используй эмозди 🤖. В поле "title" должно быть придумано лаконичное название, ёмко характеризующее всё обсуждение целиком. Отвечай всегда на языке с кодом {lang}, если пользователь не попросил иное. Далее идёт пересказ прошлых ваших сообщений, не потеряй его в своём пересказе. Ответ должен быть в формате json.
	Dialog $mol_page
		body_content /
			<= Status $mol_status
				status <= communication null
			<= Messages $mol_list
				rows <= messages /
		foot /
			<= Avatar $mol_view sub / \🙂
			<= Attachments_preview $mol_list
				rows <= attachments_preview /
					<= Attached_image_wrap* $mol_view
						sub /
							<= Attached_image* $mol_image
								uri <= attached_image_uri* \
							<= Remove_image* $mol_button_minor
								hint @ \Remove
								click? <=> remove_image* null
								sub / <= Remove_image_icon* $mol_icon_close
					<= Attached_audio_wrap* $mol_view
						sub /
							<= Attached_audio* $mol_view
								sub /
									<= Attached_audio_icon* $mol_icon_microphone
									<= Attached_audio_name* $mol_view sub / \
							<= Remove_audio* $mol_button_minor
								hint @ \Remove
								click? <=> remove_audio* null
								sub / <= Remove_audio_icon* $mol_icon_close
			<= Prompt_attachments $mol_row sub /
				<= Prompt_image_upload $mol_button_minor
					hint @ \Attach image
					click? <=> image_upload? null
					sub / <= Prompt_image_icon $mol_icon_image
				<= Prompt_paste $mol_button_minor
					hint @ \Paste screenshot (Ctrl+V)
					click? <=> paste_screenshot? null
					sub / <= Prompt_paste_icon $mol_icon_content_paste
				<= Prompt_audio_record $mol_button_minor
					hint @ \Hold to record audio
					sub /
						<= Prompt_audio_icon $mol_icon_microphone
						<= Recording_indicator $mol_view
							sub / \⏺
			<= Prompt_text $mol_textarea
				hint @ \Ask something
				value? <=> prompt_text? \
				submit? <=> prompt_submit? null
			<= Prompt_submit $mol_button_minor
				hint @ \Send
				click? <=> prompt_submit? 
				sub /
					<= Prompt_submit_icon $mol_icon_send
